import request from '@/utils/request'

let rerulesApi = {
  /*项目列表*/
  list(data, errorback) {
    return request._post('/shop/plus.rerules.Index/index', data, errorback);
  },
  detail(data, errorback) {
    return request._post('/shop/plus.rerules.Product/detail', data, errorback);
  },
  productList(data, errorback) {
    return request._post('/shop/plus.rerules.Product/product', data, errorback);
  },
  add(data, errorback) {
    return request._post('/shop/plus.rerules.Product/add', data, errorback);
  },
  edit(data, errorback) {
    return request._post('/shop/plus.rerules.Product/edit', data, errorback);
  },
  del(data, errorback) {
    return request._post('/shop/plus.rerules.Product/del', data, errorback);
  },
  copy(data, errorback) {
    return request._post('/shop/plus.rerules.Product/copy', data, errorback);
  },
  saveSetting(data, errorback) {
    return request._post('/shop/plus.rerules.Setting/getSetting', data, errorback);
  },
  getSetting(data, errorback) {
    return request._get('/shop/plus.rerules.Setting/getSetting', data, errorback);
  },
  getGrade(data, errorback) {
    return request._get('/shop/plus.rerules.Index/getGrade', data, errorback);
  },
}
export default rerulesApi;



// WEBPACK FOOTER //
// ./src/api/rerules.js